@if (menuItems) {
    <menu class="m-0 p-0 menu d-flex flex-row flex-wrap">
        @for (item of displayMenuItems; track item) {
            <div class="menu__item me-3">
                <a class="a--border-off a--white"
                   [routerLink]="item.url"
                   [routerLinkActive]="'a--active'"
                   [attr.title]="item.mdName | translate">{{ item.mdName | translate }}</a>
            </div>
        }
    </menu>
}
